import { GetStaticPropsContext } from 'next';

import { PageCategory } from '~/features/analytics/constants';
import { DEFAULT_LANGUAGE } from '~/features/internationalization/languages';
import { PageHead } from '~/features/page/components/page-head';
import { PageLayout } from '~/features/page/components/page-layout';
import { getPage } from '~/features/page/controllers/get-page';
import { Page } from '~/features/page/models/page';
import { GetPersonalizedDiscountLayout } from '~/features/personalized-discount/components/get-personalized-discount-layout';
import { NewUserOfferForm } from '~/features/personalized-discount/components/new-user-offer-form';

export default function GetPersonalizedDiscountPage({ page }: { page: Page }) {
  return (
    <>
      <PageHead page={page} pageCategory={PageCategory.PersonalizedDiscount} />
      <PageLayout withoutVerticalPadding>
        <GetPersonalizedDiscountLayout>
          <NewUserOfferForm />
        </GetPersonalizedDiscountLayout>
      </PageLayout>
    </>
  );
}

export async function getStaticProps({ locale }: GetStaticPropsContext) {
  // Stop additional locale pages except the default locale from being built
  if (locale !== DEFAULT_LANGUAGE) {
    return {
      notFound: true,
    };
  }

  const page = await getPage('/get-personalized-discount');

  if (!page) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      page,
    },
  };
}
